import { StringUtil } from "@mcleod/core";
import { ClickEvent, OpenType, TableCrudManager, TableRow } from "@mcleod/components";

export class AppTableCrudManager extends TableCrudManager {
    override showDetailFromClick(event: ClickEvent) {
        this.showAppRowDetail(event);
    }

    public override async showAdd() {
        if (this.table.isQuickAddAllowed()) {
            if (!StringUtil.isEmptyString(this.table.editLayout))
                this.table.quickAddRow.showEditLayout();
        } else {
            super.showAdd();
        }
    }

    public showAppRowDetail(event: ClickEvent) {
        const rootLayoutMainDataSource = this.table.getRootLayout()?.mainDataSource;
        if (rootLayoutMainDataSource != null && this.table.dataSource != rootLayoutMainDataSource) {
            if (!StringUtil.isEmptyString(this.table.editLayout)) {
                const eventRow = event.target as TableRow;
                const row = eventRow || this.table.selectedRow;
                if (row) {
                    row.showEditLayout();
                }
            }
        } else {
            this.table.crudManager.showDetail(OpenType.SAME_TAB);
        }
    }
}
